(function (Drupal) {
  /**
   * Setup and attach the Carousel behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.carousel = {
    attach: function () {
      if (typeof bootstrap !== 'undefined') {
        const carouselElement = document.querySelector('.carousel-slider--homepage');

        if (carouselElement) {
          // Initialize a variable to track whether the carousel is sliding or not.
          // This comes in handy later when we want to start/stop the carousel on mouseenter/mouseleave.
          let isCarouselSliding = true;

          const carousel = new bootstrap.Carousel(carouselElement, {
            interval: 6000,
            ride: 'carousel',
            pause: false
          });

          // Add mouse event listeners to the carousel.
          carouselElement.addEventListener('mouseenter', function () {
            // We only want to affect the carousel's state if it was actually in motion before.
            // Otherwise, this can lead to unintended/confusing behavior.
            if (isCarouselSliding) {
              carousel.pause();
            }
          });
          carouselElement.addEventListener('mouseleave', function () {
            // Similarly, we want to ensure the carousel was in motion before we resume it.
            // Ex: we don't want the user to pause the carousel and then have it resume when the
            // mouse leaves the carousel.
            if (isCarouselSliding && !carouselElement.classList.contains('paused')) {
              carousel.cycle();
            }
          });

          const sliderPause = carouselElement.querySelector('.btn-play-pause');
          // Add click event listener to the pause button (only if one hasn't already been added).
          if (sliderPause && !sliderPause.hasAttribute('data-event-attached')) {
            sliderPause.addEventListener('click', function (e) {
              if (carouselElement.classList.contains('paused')) {
                const icon = sliderPause.querySelector('.icon');
                icon.innerHTML = 'pause_circle_outline';
                carousel.cycle();
                isCarouselSliding = true;
              }
              else {
                const icon = sliderPause.querySelector('.icon');
                icon.innerHTML = 'play_circle';
                carousel.pause();
                isCarouselSliding = false;
              }
              carouselElement.classList.toggle('paused');
            });
            sliderPause.setAttribute('data-event-attached', 'true');
          }
        }

        const carouselHomeInner = document.querySelectorAll(
          '.carousel-slider--homepage .carousel-inner .carousel-item .carousel-caption-inner'
        );

        if (carouselHomeInner) {
          var maxHomeHeight = 0;
          carouselHomeInner.forEach(function (element) {
            if (element.clientHeight > maxHomeHeight) {
              maxHomeHeight = element.clientHeight;
            }
            element.style.height = maxHomeHeight + 'px';
          });
        }
      }
    }
  };
})(Drupal);
